interface ExtractionStatusProps {
  count: number;
}

/**
 * Small live indicator showing how many extraction jobs are currently running.
 * Rendered in the toolbar next to the Run-extraction button.
 */
export function ExtractionStatus({ count }: ExtractionStatusProps) {
  if (count <= 0) return null;
  return (
    <div className="sp-extraction" title="Queue aktualisiert sich alle 10s">
      <span className="dot" />
      <span className="sp-extraction-num">{count}</span>
      <span>{count === 1 ? 'Extraktion läuft' : 'Extraktionen laufen'}</span>
    </div>
  );
}
